"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDeleteAppFlavour = exports.useUpdateAppFlavour = exports.useCreateAppFlavour = exports.useFetchAppFlavour = void 0;
const react_redux_1 = require("react-redux");
const react_router_1 = require("react-router");
const AuthGuard_1 = require("../../components/tsComponents/AuthGuard");
const appFlavourAction_1 = require("./appFlavourAction");
const useFetchAppFlavour = () => {
    const dispatch = (0, react_redux_1.useDispatch)();
    const history = (0, react_router_1.useNavigate)();
    const getAppsForTerminalLoading = (0, react_redux_1.useSelector)((state) => state['appFlavour/fetch'].loading);
    const getAppsForTerminalData = (0, react_redux_1.useSelector)((state) => state['appFlavour/fetch'].data);
    const getAppsForTerminalError = (0, react_redux_1.useSelector)((state) => state['appFlavour/fetch'].error);
    const getAppsForTerminal = () => __awaiter(void 0, void 0, void 0, function* () {
        try {
            let userLogged = yield (0, AuthGuard_1.isLoggedIn)();
            if (!userLogged) {
                history('/auth/sign-in');
                return;
            }
            yield dispatch((0, appFlavourAction_1.fetch)());
        }
        catch (error) {
            throw new Error('Error in getting apps');
        }
    });
    return {
        getAppsForTerminalLoading,
        getAppsForTerminalData,
        getAppsForTerminalError,
        getAppsForTerminal
    };
};
exports.useFetchAppFlavour = useFetchAppFlavour;
const useCreateAppFlavour = () => {
    const dispatch = (0, react_redux_1.useDispatch)();
    const history = (0, react_router_1.useNavigate)();
    const createAppFlavourLoading = (0, react_redux_1.useSelector)((state) => state['appFlavour/create'].loading);
    const createAppFlavourData = (0, react_redux_1.useSelector)((state) => state['appFlavour/create'].data);
    const createAppFlavourError = (0, react_redux_1.useSelector)((state) => state['appFlavour/create'].error);
    const createAppFlavour = (payload, onComplete) => __awaiter(void 0, void 0, void 0, function* () {
        try {
            let userLogged = yield (0, AuthGuard_1.isLoggedIn)();
            if (!userLogged) {
                history('/auth/sign-in');
                return;
            }
            const res = yield dispatch((0, appFlavourAction_1.create)(payload));
            if (res.meta.requestStatus === 'fulfilled') {
                onComplete(true, false, res.payload);
            }
            else if (res.meta.requestStatus === 'rejected') {
                throw new Error('Error in creating App flavor');
            }
        }
        catch (error) {
            onComplete(false, true, error.message);
        }
    });
    return {
        createAppFlavourLoading,
        createAppFlavourData,
        createAppFlavourError,
        createAppFlavour
    };
};
exports.useCreateAppFlavour = useCreateAppFlavour;
const useUpdateAppFlavour = () => {
    const dispatch = (0, react_redux_1.useDispatch)();
    const history = (0, react_router_1.useNavigate)();
    const updateAppFlavourLoading = (0, react_redux_1.useSelector)((state) => state['appFlavour/update'].loading);
    const updateAppFlavourData = (0, react_redux_1.useSelector)((state) => state['appFlavour/update'].data);
    const updateAppFlavourError = (0, react_redux_1.useSelector)((state) => state['appFlavour/update'].error);
    const updateAppFlavour = (payload, onComplete) => __awaiter(void 0, void 0, void 0, function* () {
        try {
            let userLogged = yield (0, AuthGuard_1.isLoggedIn)();
            if (!userLogged) {
                history('/auth/sign-in');
                return;
            }
            const res = yield dispatch((0, appFlavourAction_1.update)(payload));
            if (res.meta.requestStatus === 'fulfilled') {
                onComplete(true, false, res.payload);
            }
            else if (res.meta.requestStatus === 'rejected') {
                throw new Error('Error in updating terminal online');
            }
        }
        catch (error) {
            onComplete(false, true, error.message);
        }
    });
    return {
        updateAppFlavourLoading,
        updateAppFlavourData,
        updateAppFlavourError,
        updateAppFlavour
    };
};
exports.useUpdateAppFlavour = useUpdateAppFlavour;
const useDeleteAppFlavour = () => {
    const dispatch = (0, react_redux_1.useDispatch)();
    const history = (0, react_router_1.useNavigate)();
    const deleteAppFlavourLoading = (0, react_redux_1.useSelector)((state) => state['appFlavour/delete'].loading);
    const deleteAppFlavourData = (0, react_redux_1.useSelector)((state) => state['appFlavour/delete'].data);
    const deleteAppFlavourError = (0, react_redux_1.useSelector)((state) => state['appFlavour/delete'].error);
    const deleteAppFlavour = (payload, onComplete) => __awaiter(void 0, void 0, void 0, function* () {
        try {
            let userLogged = yield (0, AuthGuard_1.isLoggedIn)();
            if (!userLogged) {
                history('/auth/sign-in');
                return;
            }
            const res = yield dispatch((0, appFlavourAction_1.deleteApp)(payload));
            if (res.meta.requestStatus === 'fulfilled') {
                onComplete(true, false, res.payload);
            }
            else if (res.meta.requestStatus === 'rejected') {
                throw new Error('Error in deleting terminal online');
            }
        }
        catch (error) {
            onComplete(false, true, error.message);
        }
    });
    return {
        deleteAppFlavourLoading,
        deleteAppFlavourData,
        deleteAppFlavourError,
        deleteAppFlavour
    };
};
exports.useDeleteAppFlavour = useDeleteAppFlavour;
